import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIResource } from "../../constants/application";
import { getUrl } from "utils/core";
import axiosInstance from "utils/axiosInstance";

interface IValidateIFSC {
  IFSC: string;
}
export interface IBankBranchDetails {
  ifscCode: string;
  address: string;
  bank: string;
}

export const ValidateIFSC = createAsyncThunk(
  "validateIFSC",
  async ({ IFSC }: IValidateIFSC, thunkAPI) => {
    const { dispatch } = thunkAPI;
    try {
      const response = await axiosInstance(
        getUrl(`${APIResource.IFSC}${IFSC}`)
      );
      if (response?.data?.error) {
        dispatch(setBankDetails({ value: IFSC }));
        return thunkAPI.rejectWithValue(response.data?.message);
      } else {
        dispatch(setBankDetails({ value: response.data }));
      }
    } catch (error: any) {
      dispatch(setBankDetails({ value: IFSC }));
      if (error?.response?.status === 404) {
        return thunkAPI.rejectWithValue("Invalid IFSC Code. Please enter a valid IFSC code.");
      } else if (error?.response?.data?.message) {
        return thunkAPI.rejectWithValue(error?.response?.data?.message);
      } else {
        return thunkAPI.rejectWithValue(
          "Something went wrong, Please contact Bayer customer support"
        );
      }
    }
  }
);

const IFSCSlice = createSlice({
  name: "validateIFSC",
  initialState: {
    loading: false,
    error: "",
    success: false,
    bankDetails: null,
  },
  reducers: {
    setBankDetails: (state, action) => {
      state.bankDetails = action.payload.value;
    },
    clearBankDetails: (state) => {
      state.bankDetails = null;
    },
    setError: (state, action) => {
      state.error = action.payload.value;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(ValidateIFSC.pending, (state) => {
      state.loading = true;
      state.error = "";
      state.success = false;
    });
    builder.addCase(ValidateIFSC.fulfilled, (state) => {
      state.loading = false;
      state.success = true;
    });
    builder.addCase(ValidateIFSC.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload as string;
    });
  },
});
export const { setBankDetails, clearBankDetails, setError } = IFSCSlice.actions;
export default IFSCSlice.reducer;
